import axios from 'axios'
import {
  Message
} from 'element-ui'
import QS from 'qs';
import store from '@/vuex/store'
import router from '@/router'

//根据开发环境配置域名
let LocationHostName = window.location.hostname;
let baseURL = ''
if (process.env.NODE_ENV === 'development' && (LocationHostName === 'localhost' || LocationHostName === '127.0.0.1')) {
  baseURL = '/api/';
} else {
  baseURL = `https://${LocationHostName}/bms`;
}
axios.defaults.baseURL = baseURL;
//设置请求超时
axios.defaults.timeout = 50000;
// 设置请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8';
// 请求拦截器
axios.interceptors.request.use(config => {
  // 在发送请求之前做些什么
  const token = store.state.token || localStorage.getItem("token");
  //判断是否存在token，如果存在将每个页面header都添加token
  if (token) {
    config.headers.common['yj-admin-token'] = token;
  }

  return config;
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
})

// 响应拦截器
axios.interceptors.response.use(
  response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  error => {
    return Promise.reject(error)
  }
)
// get 方法
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params
    }).then(res => {
      if (res.data.code == 3) {
        router.push({
          path: '/login'
        });
      } else {
        resolve(res.data)
      }
    }).catch(error => {
      console.log(JSON.stringify(error))
      resolve({ code: -3, message: '网络出错了' })
    })
  })
}

// post 方法
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params).then(res => {
      if (res.data.code == 3) {
        router.push({
          path: '/login'
        });
      } else {
        resolve(res.data)
      }

    }).catch(error => {
      console.log(JSON.stringify(error))
      resolve({ code: -3, message: '网络出错了' })
    })
  })
}

// del 方法
export function del(url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      params:params
    }).then(res => {
      // console.log('post++++++++++++++'+JSON.stringify(res.code));
      if (res.data.code == 3) {
        router.push({
          path: '/login'
        });
      } else {
        resolve(res.data)
      }

    }).catch(error => {
      console.log(JSON.stringify(error))
      resolve({ code: -3, message: '网络出错了' })
    })
  })
}

// put 方法
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, params).then(res => {
      // console.log('post++++++++++++++'+JSON.stringify(res.code));
      if (res.data.code == 3) {
        router.push({
          path: '/login'
        });
      } else {
        resolve(res.data)
      }

    }).catch(error => {
      console.log(JSON.stringify(error))
      resolve({ code: -3, message: '网络出错了' })
    })
  })
}

export function request(option) {
  if (String(option) !== '[object Object]') return undefined
  option.method = option.method ? option.method.toUpperCase() : 'GET'
  option.data = option.data || {}
  var formData = []
  for (var key in option.data) {
    formData.push(''.concat(key, '=', option.data[key]))
  }
  option.data = formData.join('&')

  if (option.method === 'GET') {
    option.url += location.search.length === 0 ? ''.concat('?', option.data) : ''.concat('&', option.data)
  }

  var xhr = new XMLHttpRequest()
  xhr.responseType = option.responseType || 'json'
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        if (option.success && typeof option.success === 'function') {
          option.success(xhr.response)
        }
      } else {
        if (option.error && typeof option.error === 'function') {
          option.error()
        }
      }
    }
  }
  xhr.open(option.method, option.url, true)
  if (option.method === 'POST') {
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
  }
  xhr.send(option.method === 'POST' ? option.data : null)
}
export default {};



// WEBPACK FOOTER //
// ./src/utils/request.js